import React from "react";
import { Button } from "react-bootstrap";
import { UseFormReturn, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as RemoveSVG } from "go-core/images/svg/actions/remove.svg";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { WebhookApi, WebhookSettingType } from "../services/types";

interface Props {
	form: UseFormReturn<WebhookApi>;
}

const WebhookSettingsForm = ({ form }: Props) => {
	const isMobile = useWindowSize().isMobile;
	const { t } = useTranslation();
	const {
		control,
		formState: { errors },
		register,
	} = form;
	const { fields, remove, append } = useFieldArray({ name: "settings", control });
	const typeOptions = [
		{
			value: WebhookSettingType.HEADER,
			label: t("lib:enums.webhook.settings.type.HEADER"),
		},
		{
			value: WebhookSettingType.PARAM,
			label: t("lib:enums.webhook.settings.type.PARAM"),
		},
	];

	const handleAppend = () => {
		append(
			{
				type: null,
				name: "",
				value: "",
			},
			{ shouldFocus: false }
		);
	};

	return (
		<fieldset className="form-group">
			<h5>{t("lib:go_component.webhook.form.settings.label")}</h5>
			<div className={`${isMobile ? "table-responsive" : ""}`}>
				<table className="table table-form">
					<thead>
						<tr>
							<th className="action" />
							<th style={{ minWidth: isMobile ? "175px" : "unset" }}>{t("lib:common.word.type")}</th>
							<th style={{ minWidth: isMobile ? "225px" : "unset" }}>{t("lib:common.word.name")}</th>
							<th style={{ minWidth: isMobile ? "225px" : "unset" }}>
								{t("lib:go_component.webhook.form.value.label")}
							</th>
							<th className="action" />
						</tr>
					</thead>
					<tbody>
						{fields.map((field, index) => {
							return (
								<tr key={field.id}>
									<td className="action" />
									<td>
										<FormSelectGroup
											name={`settings.${index}.type`}
											control={control}
											options={typeOptions}
											errors={errors}
											data-testid={`settings.${index}.type`}
											openMenuOnFocus
										/>
									</td>
									<td>
										<FormInput
											name={`settings.${index}.name`}
											register={register}
											errors={errors}
										/>
									</td>
									<td>
										<FormInput
											name={`settings.${index}.value`}
											register={register}
											errors={errors}
										/>
									</td>
									<td className="action">
										<RemoveSVG className="icon" onClick={() => remove(index)} />
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			<Button variant="add" onClick={handleAppend}>
				{`+ ${t("lib:common.action.add")}`}
			</Button>
		</fieldset>
	);
};

export default WebhookSettingsForm;
